export default "# Taşınmış\n\nBu konu kullanıcı kılavuzunun parçası değildir. Bkz. [Başlangıç](/docs/getting-started).\n"